
import { CsvUtilFileUpload } from "@/features/csv-utils/components/FileUpload";
import { AnalysisDashboard } from "@/features/csv-utils/components/analysis/AnalysisDashboard";
import { SectionWrapper } from "@/features/csv-utils/components/layout/SectionWrapper";
import { FundResearch } from "@/features/csv-utils/components/FundResearch";
import { ExportFundData } from "@/components/research/ExportFundData";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function CsvUtilsContent() {
  return (
    <Tabs defaultValue="analysis" className="space-y-4">
      <TabsList>
        <TabsTrigger value="analysis">CSV Analysis</TabsTrigger>
        <TabsTrigger value="research">Research</TabsTrigger>
      </TabsList>

      <TabsContent value="analysis">
        <SectionWrapper>
          <CsvUtilFileUpload />
        </SectionWrapper>

        <SectionWrapper className="bg-[#D3E4FD]/30">
          <AnalysisDashboard />
        </SectionWrapper>
      </TabsContent>

      <TabsContent value="research">
        <SectionWrapper>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <FundResearch />
            </div>
            <div>
              <ExportFundData />
            </div>
          </div>
        </SectionWrapper>
      </TabsContent>
    </Tabs>
  );
}
